import { Link } from 'react-router-dom';

// TODO: 換成你的正式客服電郵（Google 同意畫面亦需要同一個 support email）
const CONTACT_EMAIL = 'support@fatematch.app';
const UPDATED = '2026年6月15日';

const Section = ({ n, title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-serif text-[#1A1A1A] mb-3">{n}. {title}</h2>
    <div className="text-sm leading-relaxed text-[#4A4A4A] space-y-2">{children}</div>
  </section>
);

const Privacy = () => (
  <div className="min-h-screen bg-[#FDFBF7] py-12 px-6">
    <div className="max-w-3xl mx-auto">
      <Link to="/" className="text-sm text-[#C93B2B] hover:underline">← 返回首頁</Link>
      <h1 className="text-3xl font-serif text-[#1A1A1A] mt-6 mb-2">隱私政策</h1>
      <p className="text-xs text-[#9A9A9A] mb-6">最後更新：{UPDATED}</p>

      <p className="text-sm leading-relaxed text-[#4A4A4A] mb-8">
        本隱私政策說明命理配對平台（下稱「本平台」「我們」）如何收集、使用、儲存及保護你的個人資料。使用本平台即表示你已閱讀並同意本政策。
      </p>

      <Section n="1" title="我們收集的資料">
        <p>透過 Google 登入：你的電郵地址、姓名、個人頭像及 Google 帳號識別碼。</p>
        <p>你主動提供：求測資料（出生日期、出生時間、性別、地區）、驗證問題、與命理師的聊天訊息、舉報內容。</p>
        <p>平台活動：你的求測單、命理師答案、訂單及付款紀錄。</p>
        <p>技術資料：登入 session、基本使用紀錄。</p>
      </Section>

      <Section n="2" title="我們如何使用資料">
        <p>提供命理配對及諮詢服務；建立及管理你的帳號；處理訂單與付款；維護平台安全、防範詐騙及處理舉報；提供用戶支援；改善服務品質。</p>
      </Section>

      <Section n="3" title="資料分享與第三方">
        <p>Google：用於登入驗證。</p>
        <p>付款服務商（例如 Stripe，於啟用後）：用於處理付款。</p>
        <p>命理師：當你選擇某位命理師，相關求測內容會提供予該命理師以便提供服務。</p>
        <p>法律要求：在法律或主管機關要求下，我們可能需要披露相關資料。</p>
        <p>我們<strong>不會出售</strong>你的個人資料。</p>
      </Section>

      <Section n="4" title="Cookie">
        <p>我們使用必要的 session cookie 來維持你的登入狀態。停用相關 cookie 可能令你無法正常使用本平台。</p>
      </Section>

      <Section n="5" title="資料保留與刪除">
        <p>我們會在你的帳號存續期間保留你的資料；你可隨時要求刪除帳號及相關個人資料（法律要求保留者除外）。</p>
      </Section>

      <Section n="6" title="你的權利">
        <p>你有權查閱、更正或刪除你的個人資料，並可撤回先前的同意。如需行使權利，請以下方電郵聯絡我們。</p>
      </Section>

      <Section n="7" title="資料安全">
        <p>我們採取合理的技術及管理措施保護你的資料，惟互聯網傳輸無法保證絕對安全。</p>
      </Section>

      <Section n="8" title="未成年人">
        <p>本服務不面向未滿 18 歲人士。如你未滿 18 歲，請勿使用本平台。</p>
      </Section>

      <Section n="9" title="政策修訂">
        <p>我們可能不時更新本政策，重大變更會於本平台公告。</p>
      </Section>

      <Section n="10" title="聯絡我們">
        <p>如對本政策有任何疑問，請電郵：<a href={`mailto:${CONTACT_EMAIL}`} className="text-[#C93B2B] hover:underline">{CONTACT_EMAIL}</a></p>
      </Section>
    </div>
  </div>
);

export default Privacy;
